import React, { useRef } from 'react';
import { WindowInformation } from '../../../services/window-information';
import BasicModal from '../../../components/BasicModal';
import { translate } from '../../../services/translate';

interface Props {
    videoUrl: string;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function VideoModal({ videoUrl, isModalVisible, setIsModalVisible }: Props) {
    const windowInfo = WindowInformation();

    const videoRef = useRef<HTMLVideoElement>(null);

    return <BasicModal
        isModalVisible={isModalVisible}
        setModalVisible={setIsModalVisible}
        title={translate('attachment')}
        width='extra-large'
        cancelButton={{
            customText: translate('close'),
        }}
    >
        <video ref={videoRef} width={windowInfo.width - (24 * 2)} height={windowInfo.height - 200} controls>
            <source src={videoUrl} type='video/mp4' />
        </video>
    </BasicModal>;
}
